import { ColorPalette } from '@/components/GradientMesh/types';
import Color from 'color';

export const GRADIENT_MESH: ColorPalette = {
  A: Color('#D5F0EA'),
  B: Color('#099E8A'),
  C: Color('#D6FF53'),
  D: Color('#00FFE0'),
};
